import { BaseLayoutFactory } from '../../../components/base-layout-factory';
import { UnidEntitySearchProvider } from './context/unid-entity-search-context';
import { UnidEntitySearchComponent } from './unid-entity-search-component';

export function UnidEntitySearchFactory() {
    return (
        <BaseLayoutFactory>
            <UnidEntitySearchProvider>
                <UnidEntitySearchComponent />
            </UnidEntitySearchProvider>
        </BaseLayoutFactory>
    );
}
